/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Fact_RibbonInputs */

const en_wc_fact_ribbon = /** @type {(inputs: Wc_Fact_RibbonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`88%`)
};

/**
* | output |
* | --- |
* | "88%" |
*
* @param {Wc_Fact_RibbonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_fact_ribbon = /** @type {((inputs?: Wc_Fact_RibbonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Fact_RibbonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_fact_ribbon(inputs)
});
export { wc_fact_ribbon as "wc.fact.ribbon" }